import { DocumentNode, gql } from '@apollo/client';
import { Link, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { usePermissions } from '@/hooks/usePermissions';

import { AuthorDetail_EventAlertFragment } from './graphql-types/AuthorDetail_EventAlertFragment';

import { GroupLinkName } from './GroupLinkName';

export const AuthorDetail: React.FC<{
  eventAlert: AuthorDetail_EventAlertFragment;
}> & {
  eventAlertFragment: DocumentNode;
} = ({ eventAlert }) => {
 
  const { canAccessCommunityAndGroupFeed } = usePermissions();

  return (
    <Text textStyle="body">
      <Link as={NextLink} href={`/members/${eventAlert.author._id}`}>
        {eventAlert.author.displayName}
      </Link>

      {eventAlert.alertType === "RECORDING_AVAILABLE" ? (
        <> Published Recording</>
      ) : eventAlert.event?.visibility.groupIds.length ? (
        <>
          <Text as="span" mx="1">
          created a new event in
          </Text>
          {eventAlert.event.visibility.groupIds.map((groupId, index) => (
            <React.Fragment key={groupId}>
              {index !== 0 && ', '}
              <GroupLinkName
                canAccessCommunityAndGroupFeed={canAccessCommunityAndGroupFeed}
                groupId={groupId}
              />
            </React.Fragment>
          ))}
        </>
      ) : (
        <> created a new event</>
      )}
    </Text>
  );
};

AuthorDetail.eventAlertFragment = gql`
  fragment AuthorDetail_EventAlertFragment on EventAlert {
    _id
    alertType
    author {
      _id
      displayName
    }
    currentUserIsPostAuthor
    event {
      _id
      visibility {
        groupIds
      }
    }
  }
`;
